import { EUrokovaSazba } from 'enums/isin/udaje/urokovaSazba';

export const urokovaSazbaDluhopis = [
    {
        value: EUrokovaSazba.F,
        labelcz: 'ISIN_EMISE_DLUHOPIS_SAZBA_F'
    },
    {
        value: EUrokovaSazba.V,
        labelcz: 'ISIN_EMISE_DLUHOPIS_SAZBA_V'
    },
    {
        value: EUrokovaSazba.Z,
        labelcz: 'ISIN_EMISE_DLUHOPIS_SAZBA_Z'
    },
    {
        value: EUrokovaSazba.J,
        labelcz: 'ISIN_EMISE_DLUHOPIS_SAZBA_JINA'
    }
];
